import { Routes } from '@angular/router';
import { accountIdsResolver, canActivateRoute } from './auth';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: async () => import('@app/layout').then((m) => m.DefaultLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/vendas',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardVendasComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/vendas-externas',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardVendasExternasComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/vendas-whatsapp',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardVendasWhatsappComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/frente-caixa',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardFrenteCaixaComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/receber',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardReceberComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/pagar',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardPagarComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/estoque',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardEstoqueComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/compras',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardComprasComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/financeiro',
        redirectTo: 'dashboard/saude-financeira',
        pathMatch: 'full',
      },
      {
        path: 'dashboard/fiscal',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardFiscalComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'dashboard/saude-financeira',
        loadComponent: async () => import('@app/pages/dashboard').then((m) => m.DashboardSaudeFinanceiraComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'assistente-gestor',
        loadComponent: async () => import('@app/pages/assistente-gestor').then((m) => m.AssistenteGestorComponent),
        canActivate: [canActivateRoute],
        resolve: { accountIds: accountIdsResolver },
      },
      {
        path: 'perfil',
        loadComponent: async () => import('@app/pages/perfil').then((m) => m.PerfilComponent),
        canActivate: [canActivateRoute],
      },
    ],
  },
  {
    path: 'signin',
    loadComponent: async () => import('@app/auth').then((m) => m.SigninComponent),
  },
  {
    path: 'signup',
    loadComponent: async () => import('@app/auth').then((m) => m.SignupComponent),
  },
  {
    path: 'forgot',
    loadComponent: async () => import('@app/auth').then((m) => m.ForgotComponent),
  },
  {
    path: 'magic-link',
    loadComponent: async () => import('@app/auth').then((m) => m.MagicLinkComponent),
  },
  {
    path: 'otp',
    loadComponent: async () => import('@app/auth').then((m) => m.OtpComponent),
  },
  {
    path: 'whatsapp',
    loadComponent: async () => import('@app/auth').then((m) => m.WhatsappLoginComponent),
  },
  {
    path: 'reset',
    loadComponent: async () => import('@app/auth').then((m) => m.ResetComponent),
  },
  {
    path: 'confirm',
    loadComponent: async () => import('@app/auth').then((m) => m.ConfirmComponent),
  },
  {
    path: 'termos',
    loadComponent: async () => import('@app/legal').then((m) => m.LegalPageComponent),
    data: { document: 'terms' },
  },
  {
    path: 'privacidade',
    loadComponent: async () => import('@app/legal').then((m) => m.LegalPageComponent),
    data: { document: 'privacy' },
  },
  {
    path: 'error',
    loadComponent: async () => import('@app/error').then((m) => m.ErrorComponent),
  },
  {
    path: '**',
    redirectTo: 'error',
    pathMatch: 'full',
  },
];
